export default __webpack_public_path__ + "static/media/github.70c30a1a.svg";